import { Box, Heading, Modal, ModalTrigger, Paragraph, TextButton } from '@zillow/constellation-10';

import { useSelector } from '../../../selectors/useSelector';

import { useGetListingSummary } from '../../../hooks/queries/summary';

type AboutAddressEditsModalProps = {
  setShowAboutAddressModal: (newShowAboutAddressModal: boolean) => void;
  setAddPropertyModalConfig: (newAddPropertyModalConfig: { isOpen: boolean; behavior: 'Add' | 'Edit' }) => void;
};

const bodyText =
  "Once a property is created, its unique property address can't be edited. Instead, create a new property with the correct address.";

const AboutAddressEditsModal = ({
  setShowAboutAddressModal,
  setAddPropertyModalConfig,
}: AboutAddressEditsModalProps): JSX.Element | null => {
  const {
    properties: {
      currentProperty: { listingAlias },
    },
  } = useSelector((state) => state);

  const { data: { isCloneListingRestricted = false } = {} } = useGetListingSummary(listingAlias);

  const showCreatePropertyModal = (): void => {
    setAddPropertyModalConfig({ isOpen: true, behavior: 'Add' });
    setTimeout(() => setShowAboutAddressModal(false), 300);
  };

  const handleCloneThisListingClick = () => {
    setTimeout(() => setShowAboutAddressModal(false), 300);
  };

  return (
    <Modal
      header={
        <Heading level={1} textStyle="heading-xs">
          About address edits
        </Heading>
      }
      body={
        <>
          <Heading level={2} textStyle="heading-sm">
            The property address can&#39;t be changed
          </Heading>

          <Paragraph css={{ marginBlock: '400' }}>{bodyText}</Paragraph>

          <Box
            css={{
              display: 'flex',
              flexDirection: 'column',
              gap: '400',
              alignItems: 'flex-start',
              marginBottom: '400',
            }}
          >
            <TextButton onClick={showCreatePropertyModal}>Create a new property</TextButton>

            {!isCloneListingRestricted && (
              <ModalTrigger multiModalTriggerId="CloneThisListingConversionModal">
                <TextButton onClick={handleCloneThisListingClick}>Clone this property</TextButton>
              </ModalTrigger>
            )}
          </Box>
        </>
      }
      onOpenChange={(open) => setShowAboutAddressModal(open)}
      open={true}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default AboutAddressEditsModal;
